import { atomWithReset } from 'jotai/utils';

import { ALL_ASSIGNMENTS_ID } from 'constants/filters';

export const selectedAssignmentIdAtom = atomWithReset(ALL_ASSIGNMENTS_ID);
